/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon24Solid = forwardRef('WarningTriangleIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.906 3.175c.954-1.567 3.233-1.567 4.188 0l7.985 13.111c.992 1.63-.184 3.714-2.094 3.714H4.015c-1.91 0-3.086-2.084-2.094-3.713L9.906 3.175Zm3.344 12.878a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13 7.845a1 1 0 1 0-2 0v4.407a1 1 0 1 0 2 0V7.845Z" })));
});
